import { ShowCaseActionType } from "./enums/showCaseActionType";

export class CreditCalcData {

    /// Минимальная сумма кредита.
    public SumFrom: number = 0;

    /// Максимальная сумма кредита.
    public SumTo: number = 0;

    /// Минимальный срок кредита (мес.)
    public PeriodFrom: number = 0;

    /// Максимальный срок кредита (мес.)
    public PeriodTo: number = 0;

    /// Заголовок страхования.
    public InsuranceCaption: string = "";

    /// Описание страхования.
    public InsuranceDetail: string = "";

    /// Тип действия для просмотра условий страхования.
    public ActionType: ShowCaseActionType = ShowCaseActionType.None;

    /// Ссылка на просмотр условий страхования.
    public ActionLink: string = "";

    /// Описание по расчету.
    public Description: string = "";

    /// Текст, при отключенном страховании.
    public FalseInsuranceTumblerDescription: string = "";

    /// Дефолтное значение суммы.
    public DefaultSum: number = 0;

    /// Дефолтное значение периода.
    public DefaultPeriod: number = 0;

    constructor(src: any) {
        this.SumFrom = isNaN(parseInt(src.sumFrom)) ? 0 : parseInt(src.sumFrom);
        this.SumTo = isNaN(parseInt(src.sumTo)) ? 0 : parseInt(src.sumTo);
        this.PeriodFrom = isNaN(parseInt(src.periodFrom)) ? 0 : parseInt(src.periodFrom);
        this.PeriodTo = isNaN(parseInt(src.periodTo)) ? 0 : parseInt(src.periodTo);
        this.InsuranceCaption = src.insuranceCaption ?? "";
        this.InsuranceDetail = src.insuranceDetail ?? "";
        this.ActionLink = src.actionLink ?? "";
        this.ActionType = (src.actionType as ShowCaseActionType) ?? ShowCaseActionType.None;
        this.Description = src.description ?? "";
        this.FalseInsuranceTumblerDescription = src.falseInsuranceTumblerDescription ?? "";
        this.DefaultSum = isNaN(parseFloat(src.defaultSum)) ? 0 : parseFloat(src.defaultSum);
        this.DefaultPeriod = isNaN(parseInt(src.defaultPeriod)) ? 0 : parseInt(src.defaultPeriod);
    }
}